import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import AuthService from './AuthService';
import {message} from "antd";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const authService = useMemo(() => new AuthService(), []);

    useEffect(() => {
        if (authService.isAuthenticated()) {
            authService.clearLegacyNavigationState();
            setIsAuthenticated(true);
            setUser(authService.getStoredUser());
        } else {
            setIsAuthenticated(false);
            setUser(null);
        }
        setLoading(false);
    }, [authService]);

    const login = async (email, password) => {
        const result = await authService.login(email, password);
        if (result.success) {
            setIsAuthenticated(true);
            setUser(result.user);
        } else {
            message.error(result.message);
        }
        return result;
    };

    const logout = () => {
        authService.logoutUser();
        setIsAuthenticated(false);
        setUser(null);
        message.info("Erfolgreich abgemeldet");
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, user, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
